import React from "react";
import "./SequenceCard.css";

const features = [
  {
    title: "Rescue Alerts",
    text: "Post injured, abandoned, or stranded animals with location, photos, audio, and clear condition details.",
  },
  {
    title: "Missing Pets",
    text: "Create missing pet alerts so nearby people can recognize, follow, and help reunite lost companions.",
  },
  {
    title: "Adoption",
    text: "Help rescued animals find families by sharing adoption posts and updates with people who care.",
  },
  {
    title: "Stray Network",
    text: "Coordinate feeding areas, feeding points, animal profiles, water refills, cleanup notes, and care history.",
  },
  {
    title: "Rescue Coordination",
    text: "Bring volunteers, NGOs, responders, and animal lovers into one rescue coordination space for faster action.",
  },
  {
    title: "Follow Updates",
    text: "Follow posts, track status changes, save important cases, and manage your activity from your profile.",
  },
];

const SequenceCard = () => {
  return (
    <section className="sequence-card-container" aria-labelledby="feature-summary-title">
      <div className="inner-container">
        <div className="sequence-heading">
          <p>Feature summary</p>
          <h1 id="feature-summary-title">One community, many ways to help</h1>
        </div>
        <div className="sequence-grid">
          {features.map((feature) => (
            <article className="sequence-feature-card" key={feature.title}>
              <h2>{feature.title}</h2>
              <p>{feature.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SequenceCard;